import { useNavigate, useParams } from 'react-router-dom';
import AdminBaseForm from '../../components/AdminBaseForm';
import { schema, uiSchema } from '../../forms/jobs';

const JobEdit = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const onSuccess = (response) => {
    navigate(`/jobs/${id}`);
  };

  const onFailure = (data) => {
    console.error(data);
  };

  return (
    <>
      {id && (
        <>
          <AdminBaseForm
            id={id}
            url='/admin/schedules'
            entityTitle='Jobs'
            schema={schema}
            uiSchema={uiSchema}
            onSuccess={onSuccess}
            onFailure={onFailure}
          />
        </>
      )}
    </>
  );
};

export default JobEdit;
